/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ManualRequest = {
    properties: {
        temperature: {
            type: 'number',
            isRequired: true,
        },
        max_tokens: {
            type: 'number',
            isRequired: true,
        },
        user_message: {
            type: 'string',
            isRequired: true,
        },
        system_message: {
            type: 'string',
            isRequired: true,
        },
        model: {
            type: 'string',
            isRequired: true,
        },
        top_p: {
            type: 'number',
            isRequired: true,
        },
        llm: {
            type: 'LLMEnum',
        },
    },
} as const;
